import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class PlusThreeCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'cardplusthree';
        params.type = CardType.plus_three;
        super.onCreate(params);
    }
}
